import {
  Alert,
  Box,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

function TaxasLaboratorio() {
  const taxas = [
    {
      analise: "Análise físico-química da água",
      valor: 250.0,
      prazo: "10 dias úteis",
    },
    {
      analise: "Análise de solo - básica",
      valor: 180.0,
      prazo: "7 dias úteis",
    },
    {
      analise: "Análise de solo - completa",
      valor: 350.0,
      prazo: "15 dias úteis",
    },
    {
      analise: "Análise de efluentes",
      valor: 300.0,
      prazo: "12 dias úteis",
    },
    {
      analise: "Análise de emissões atmosféricas",
      valor: 450.0,
      prazo: "20 dias úteis",
    },
    {
      analise: "Análise de ruído ambiental",
      valor: 200.0,
      prazo: "5 dias úteis",
    },
    {
      analise: "Análise de resíduos sólidos",
      valor: 280.0,
      prazo: "10 dias úteis",
    },
  ];

  return (
    <Container sx={{ px: { xs: 2, sm: 3, md: 4 } }}>
      <Box sx={{ mt: { xs: 2, md: 4 }, mb: { xs: 2, md: 4 } }}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{ fontSize: { xs: "1.35rem", sm: "1.75rem", md: "2.125rem" } }}
        >
          Taxas de Laboratório
        </Typography>

        <Alert severity="info" sx={{ mb: 3 }}>
          Valores de referência para análises laboratoriais. Os preços podem
          variar conforme a complexidade e urgência da análise.
        </Alert>

        <TableContainer
          component={Paper}
          sx={{ overflowX: "auto" }}
        >
          <Table>
            <TableHead sx={{ bgcolor: "action.hover" }}>
              <TableRow>
                <TableCell sx={{ minWidth: 200 }}>Tipo de Análise</TableCell>
                <TableCell align="right" sx={{ minWidth: 120 }}>
                  Valor (R$)
                </TableCell>
                <TableCell align="right" sx={{ minWidth: 120 }}>
                  Prazo
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {taxas.map((taxa, index) => (
                <TableRow key={index}>
                  <TableCell>{taxa.analise}</TableCell>
                  <TableCell align="right">
                    {taxa.valor.toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </TableCell>
                  <TableCell align="right">{taxa.prazo}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Container>
  );
}

export default TaxasLaboratorio;
